import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { FeedbackId, CompactAssistantFeedbackResponse, AssistantFeedbackResponse, FeedbacksRequest } from '@business/entities/assistant_feedback';
import { AssistantFeedbackAPI } from '@business/api/assistant_feedback';
import { tap } from 'rxjs';

export class AssistantFeedbackBloc extends BaseBloc {
  private readonly feedbackRepo = new Repository<CompactAssistantFeedbackResponse | AssistantFeedbackResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.feedbackRepo.items$;
  readonly selectItem = this.feedbackRepo.selectItem;

  onReset() {
    this.feedbackRepo.reset();
  }

  fetchFeedbacks = (request: FeedbacksRequest) => {
    return AssistantFeedbackAPI.fetchFeedbacks(request).pipe(
      tap(items => {
        const isInitialLoad = !request.page || request.page === 1;
        const isEmpty = items.data.length === 0;

        if (isInitialLoad) {
          // Page 1 with empty = filter returned no results → clear repo
          this.feedbackRepo.reset();
        }

        if (!isEmpty) {
          this.feedbackRepo.addMany(items.data);
        }

        return items;
      }),
    );
  };

  fetchFeedback = (id: FeedbackId) => {
    return AssistantFeedbackAPI.fetchFeedback(id).pipe(
      this.feedbackRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_feedbacks_error') }),
    );
  };

  createComment = (feedbackId: FeedbackId, comment: string) => {
    return AssistantFeedbackAPI.createComment(feedbackId, comment).pipe(
      this.feedbackRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_idea_comment'),
      }),
    );
  };
}
